export const SHELL_TOGGLE_BUTTON_CLASS = [
  'h-6 w-6',
  'flex items-center justify-center',
  'rounded-full',
  'border border-white/65',
  'bg-white/80 text-slate-700',
  'shadow-[0_6px_16px_rgba(15,23,42,0.16)]',
  'ring-1 ring-slate-200/50',
  'backdrop-blur-md',
  'transition-[transform,box-shadow,background-color,color,border-color]',
  'duration-200 ease-out',
  'hover:scale-105 hover:bg-white hover:shadow-[0_10px_22px_rgba(15,23,42,0.2)]',
  'active:scale-95',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/90 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent',
  'dark:border-slate-700/80 dark:bg-slate-900/78 dark:text-sky-300/90 dark:ring-slate-700/60 dark:hover:bg-slate-900 dark:hover:text-white',
].join(' ');

export const SHELL_TOGGLE_REVEAL_BUTTON_CLASS = [
  SHELL_TOGGLE_BUTTON_CLASS,
  'rounded-b-full border-t-0',
].join(' ');

export const SHELL_TOGGLE_ICON_CLASS = 'h-3 w-3';